import React from "react";
import "../stack/stack.css";

const Stack = ({ className = "mt-1", direction = "vertical", gap = 1, children }) => {
  const stackStyle = {
    display: "flex",
    flexDirection: direction === "vertical" ? "column" : "row",
    gap: `${gap}rem`,
  };

  return <div className={className} style={stackStyle}>{children}</div>;
};

export default Stack;